const APCRDA_PROD_DOMAIN = 'https://geoportal.apcrda.org';
const APCRDA_DEV_DOMAIN = 'https://dev.apcrda.vassarlabs.com';

function resolveApcrdaDomainUrl(): string {
  if (typeof globalThis !== 'undefined' && 'location' in globalThis) {
    const hostname = (globalThis as Window & typeof globalThis).location.hostname;
    if (
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname.includes('dev.apcrda')
    ) {
      return APCRDA_DEV_DOMAIN;
    }
  }
  return APCRDA_PROD_DOMAIN;
}

const apcrdaDomainUrl = resolveApcrdaDomainUrl();

export const environment = {
  production: apcrdaDomainUrl === APCRDA_PROD_DOMAIN,
  urlMapping: {
    PROJ_API: 'https://dev.ce.vassardigital.ai/api',
    USERMGMT_API: 'https://dev.ce.vassardigital.ai/um',
    WEBSOCKET_URL: 'wss://dev.ce.vassardigital.ai/ws/chatbot/',
    DOMAIN_URL: apcrdaDomainUrl,
  },
  GOOGLE_DRIVE_PICKER_CONSTANTS: {
    CLIENT_ID: '746677174864-bsd92s7ecdt58tcbvof0399g3aaempim.apps.googleusercontent.com',
    GOOGLE_DRIVE_API_KEY: '',
    PROJECT_NUMBER: '746677174864',
    SCOPE: 'https://www.googleapis.com/auth/drive.file',
  },
  MICROSOFT_LOGIN_REQUIRED_DETAILS: {
    CLIENT_ID: 'ab38135d-6d89-4fde-81a6-81c2c9bad599',
    LOCAL_REDIRECT_URI: 'https://dev.ce.vassardigital.ai/onedrive-callback',
    TENANT_ID: 'cb62c76b-3871-4534-b2c6-3c78c8a29d1c',
    AUTHORITY: 'https://login.microsoftonline.com/common',
  },
};
